import { makeAutoObservable, runInAction, reaction, observable } from "mobx";
import { commonAxios } from "../../CommonAxios";
class TaskStore {
  taskList = observable.map({});
  tabIndex = -1;
  pollingInterval = null;
  timer;
  taskListanchorEl = null;
  enrichIds = null;
  taskButtonRef = null;
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
    reaction(
      () => this.tabIndex,
      (current, prev) => {
        if (current === 0 ) {
          this.taskListApi(true);
        } else {
          this.taskListApi(false);
        }
      }
    );
  }
  taskListApi = async (timer = false) => {
    try {
      const response = await commonAxios(
        "/getEnrichProgressList",
        "POST",
        {},
        {
          tableId: this.rootStore.gridStore.tabIndex === 0 ? this.rootStore.gridStore.tableCompanyId : this.rootStore.gridStore.tablePeopleId,
          userId: this.rootStore.gridStore.userId,
          enrichIds: Array.isArray(this.enrichIds)
            ? this.enrichIds.join(",")
            : "",
        }
      );
      const list = response?.data?.list || [];
      const pendingIds = (list || [])
        .filter((item) => item.status !== "completed")
        .map((item) => item.id);
      runInAction(() => {
        for (let doc of list) {
          this.taskList.set(doc.id, doc);
        }
        this.enrichIds = pendingIds;
      });
      // ✅ Start polling only if tabIndex is 0 and no interval running
      if (timer && (this.enrichIds ?? []).length) {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          this.taskListApi(true); // Keep calling itself
        }, 10000);
      } else {
        clearInterval(this.timer);
      }
    } catch (error) {
    }
  };
  areAllTasksCompleted() {
    return this.taskList.every((item) => item.completed === item.total);
  }
  setGridStore(e) {
    this.taskList.clear();
    this.taskListanchorEl = e.currentTarget;
    this.tabIndex = 0; // Trigger reaction
  }
  settabIndex(value) {
      runInAction(() => {
        this.taskListanchorEl = this.taskButtonRef || null;
        this.tabIndex = value;
      })
  }
  handleTabChange = (event, newValue) => {
    this.tabIndex = newValue; // Reaction handles everything
  };
  get completedList() {
    return Array.from(this.taskList.values()).filter(
      (item) => item.status === "completed"
    );
  }
  get pendingList() {
    return Array.from(this.taskList.values()).filter(
      (item) => item.status !== "completed"
    );
  }
  get loadingList() {
    if (this.tabIndex === 0) {
      return this.pendingList;
    } else {
      return this.completedList;
    }
  }
}
export default TaskStore;
